import React from "react";
import ReactApexChart from "react-apexcharts";
import getChartColorsArray from "../../Components/Common/ChartsDynamicColor";

const RevenueCharts = ({ dataColors, series, categories }) => {
  var linechartcustomerColors = getChartColorsArray(dataColors);

  var options = {
    chart: {
      height: 370,
      type: "line",
      toolbar: {
        show: false,
      },
    },
    stroke: {
      curve: "straight",
      dashArray: [0, 8], // Solid for Revenue (area), dashed for Orders (line)
      width: [2, 2.2],
    },
    fill: {
      opacity: [0.1, 1], // Light fill for Revenue, solid for Orders
    },
    markers: {
      size: [0, 0],
      strokeWidth: 2,
      hover: {
        size: 4,
      },
    },
    xaxis: {
      categories: categories || ["No Data"], // Use dynamic categories or fallback
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      title: {
        text: "", // Set dynamically in Revenue component
      },
    },
    grid: {
      show: true,
      xaxis: {
        lines: {
          show: true,
        },
      },
      yaxis: {
        lines: {
          show: false,
        },
      },
      padding: {
        top: 0,
        right: -2,
        bottom: 15,
        left: 10,
      },
    },
    legend: {
      show: true,
      horizontalAlign: "center",
      offsetX: 0,
      offsetY: -5,
      markers: {
        width: 9,
        height: 9,
        radius: 6,
      },
      itemMargin: {
        horizontal: 10,
        vertical: 0,
      },
    },
    plotOptions: {
      bar: {
        columnWidth: "30%",
        barHeight: "70%",
      },
    },
    colors: linechartcustomerColors,
    tooltip: {
      shared: true,
      y: [
        {
          formatter: (y) => (y !== undefined ? `DT ${y.toFixed(2)}` : "N/A"), // Revenue in DT
        },
        {
          formatter: (y) => (y !== undefined ? `${y.toFixed(0)} Orders` : "N/A"), // Order count
        },
      ],
    },
  };

  return (
      <React.Fragment>
        <ReactApexChart
            options={options}
            series={series || []}
            type="line"
            height="370"
            className="apex-charts"
        />
      </React.Fragment>
  );
};

const StoreVisitsCharts = ({ dataColors }) => {
  var chartDonutBasicColors = getChartColorsArray(dataColors);

  const series = [44, 55, 41, 17, 15];
  var options = {
    labels: ["Direct", "Social", "Email", "Other", "Referrals"],
    chart: {
      height: 333,
      type: "donut",
    },
    legend: {
      position: "bottom",
    },
    stroke: {
      show: false,
    },
    dataLabels: {
      dropShadow: {
        enabled: false,
      },
    },
    colors: chartDonutBasicColors,
  };
  return (
      <React.Fragment>
        <ReactApexChart
            options={options}
            series={series}
            type="donut"
            height="333"
            className="apex-charts"
        />
      </React.Fragment>
  );
};

export { RevenueCharts, StoreVisitsCharts };